import React, { Component } from 'react'
import { connect } from 'react-redux'
import Select from 'react-simpler-select'
import ReactTooltip from 'react-tooltip'

import Button from './UI/Button'
import NumberInput from './UI/NumberInput'

import { selectFader, setFaderMode, setFaderCC, setFaderChannel } from '../actions/'

import tooltips from '../constants/tooltips.json'

const faderModeOptions = [
  { label: 'Pitchbend', value: 0},
  { label: 'CC', value: 1}
]

class ButtonsFadersFaders extends Component {

  componentDidUpdate() {
    ReactTooltip.rebuild();
  }

render() {
  const {
    faders,
    selectedFader,
    onSelectFader,
    onSelectFaderMode,
    onSelectFaderCC,
    onSelectFaderChannel,
    showTooltips
  } = this.props

  const currentFader = faders[selectedFader]

    return (
      <div className="buttons-faders-faders">
        <Button
          kind="fader-horizontal"
          index={0}
          value={0}
          toggle={selectedFader}
          onClick={onSelectFader}
          data-tip={tooltips['editor-fader-select']}
          data-multiline="true"
          data-place="top"
          data-tip-disable={!showTooltips}
        />
        <div className="fader-mode">
          <label
            data-tip={tooltips['editor-fader-mode']}
            data-multiline="true"
            data-place="bottom"
            data-tip-disable={!showTooltips}
            >
            Fader Mode
            <Select name="faderMode" value={currentFader.mode} options={faderModeOptions} onChange={(value) => onSelectFaderMode(selectedFader, value)} />
          </label>
        </div>
        { (currentFader.mode === 1) && <NumberInput
          name="fader-cc"
          data-tip={tooltips['editor-fader-cc']}
          data-multiline="true"
          data-place="bottom"
          data-tip-disable={!showTooltips}
          min={0} max={127}
          value={currentFader.cc}
          onChange={(value) => onSelectFaderCC(selectedFader, value)} /> }
        <div className="fader-channel">
          <label
            data-tip={tooltips['editor-fader-channel']}
            data-multiline="true"
            data-place="right"
            data-tip-disable={!showTooltips}
            >
            Channel
            <NumberInput name="faderChannel" min={1} max={16} value={currentFader.channel + 1} onChange={(value) => onSelectFaderChannel(selectedFader, value - 1)} />
          </label>
        </div>
        <Button
          kind="fader-vertical-1"
          index={1}
          value={1}
          toggle={ selectedFader }
          onClick={ onSelectFader }
          data-tip={tooltips['editor-fader-select']}
          data-multiline="true"
          data-place="left"
          data-tip-disable={!showTooltips}
        />
        <Button
          kind="fader-vertical-2"
          index={2}
          value={2}
          toggle={ selectedFader }
          onClick={ onSelectFader }
          data-tip={tooltips['editor-fader-select']}
          data-multiline="true"
          data-place="left"
          data-tip-disable={!showTooltips}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    selectedFader: state.editor.selectedFader,
    faders: state.currentPreset.faders,
    showTooltips: state.editorPreferences.showTooltips
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSelectFader: (target) => {
      dispatch(selectFader(~~target.value))
    },
    onSelectFaderMode: (index, value) => {
      dispatch(setFaderMode(index, ~~value))
    },
    onSelectFaderCC: (index, value) => {
      dispatch(setFaderCC(index, ~~value))
    },
    onSelectFaderChannel: (index, value) => {
      dispatch(setFaderChannel(index, ~~value))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ButtonsFadersFaders)
